import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import jwt_decode from "jwt-decode";
import { serverUrl, fetchLandlordIds } from "../../../serverUrl";
import { toast } from "react-toastify";
import { saveAs } from 'file-saver';
import loaderImageGif from "../../../assets/img/kodi_loader.gif";
import ReconcilePaymentModal from './ReconcileOverPaymentModal';

function OverflowReport() {
  const [showAddOverpayment, setShowAddOverpayment] = useState(false);
  const [manualUnits, setManualUnits] = useState([]);
  const [manualApartmentId, setManualApartmentId] = useState("");
  const [isLoadingManualUnits, setIsLoadingManualUnits] = useState(false);
  const [manualOverpayment, setManualOverpayment] = useState({
    bill_ref_number: "",
    first_name: "",
    phone_number: "",
    overflow_amount: "",
    transcation_id: "",
    transcation_time: new Date().toISOString().slice(0, 10),
  });
  const { id } = useParams();
  const isAllProperties = id === 'all';
  const [landlordId, setLandlordId] = useState(null);
  const [showSidebar, setShowSidebar] = useState(true);

  function toggleSidebar() {
    setShowSidebar(!showSidebar);
  }
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [ctobTransactions, setCtobTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const accessToken = localStorage.getItem("authTokens");
  const parsedTokens = JSON.parse(accessToken);
  const access = parsedTokens.access;

  const config = {
    headers: { Authorization: `Bearer ${access}` }
  }
  const [landlordApartment, setLandlordApartment] = useState([])
  const decodedToken = jwt_decode(accessToken);
  const userId = decodedToken.user_id;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const landlordIdValue = isAllProperties ? await fetchLandlordIds() : null;
        if (isAllProperties) {
          setLandlordId(landlordIdValue);
          if (!landlordIdValue) {
            setIsLoading(false);
            return;
          }
        }
        const transactionUrl = isAllProperties
          ? `/landlord/c2btranscation/?landlord_id=${landlordIdValue}`
          : `/landlord/c2btranscation/?apartment=${id}`;
        const [transactionsRes, landlordRes] = await Promise.all([
          serverUrl.get(transactionUrl, config),
          serverUrl.get(`/landlord/landlord/?user_id=${userId}`, config)
        ]);

        // Filter out the transactions with reconciled as true and overflow amount greater than 0
        const filteredTransactions = transactionsRes.data.results.filter(transaction => transaction.overflow_amount > 0);
        setCtobTransactions(filteredTransactions);

        // get the landlord details that are linked to the user
        const landlordIds = landlordRes.data.results.map((landlord) => landlord.id);

        // using the landlord id get the apartments linked to the landlord
        const landlordApartmentPromises = landlordIds.map((landlordId) => {
          return serverUrl.get(`/landlord/landlord-apartment_name/?landlord_id=${landlordId}`, config)
            .then((res) => res.data.results)
            .catch((error) => {
              console.log(error);
              return [];
            });
        });

        const results = await Promise.all(landlordApartmentPromises);
        const apartments = results.flat();
        setLandlordApartment(apartments);

      } catch (error) {
        console.log(error);
        toast.error("Failed to load data");
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  // searching function and sorting functionalities
  const [sortType, setSortType] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);

  const handleSort = (sortField) => {
    if (sortField === sortType) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortType(sortField);
      setSortOrder("asc");
    }
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setSelectedRow(null);
    setCurrentPage(0);
  };

  const sortedData = [...ctobTransactions].sort((a, b) => {
    const sortValueA = typeof a[sortType] === "string" ? a[sortType].toLowerCase() : a[sortType];
    const sortValueB = typeof b[sortType] === "string" ? b[sortType].toLowerCase() : b[sortType];

    if (sortValueA === sortValueB) return 0;

    if (sortOrder === "asc") {
      return sortValueA > sortValueB ? 1 : -1;
    } else {
      return sortValueA < sortValueB ? 1 : -1;
    }
  });

  const filteredData = sortedData.filter((item) => {
    const searchableFields = Object.values(item).join(" ").toLowerCase();
    return searchableFields.includes(searchQuery.toLowerCase());
  });

  // Pagination
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = currentPage * itemsPerPage;
  const endIndex = currentPage === totalPages - 1 ? filteredData.length : startIndex + itemsPerPage;
  const displayedItems = filteredData.slice(startIndex, endIndex);

  const handlePrevPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  // modal for adding reconciliation
  const [showModal, setShowModal] = useState(false)
  const [showModalPayment, setShowModalPayment] = useState(false)
  const [recordId, setRecordId] = useState('')
  const [selectedRecord, setSelectedRecord] = useState(null)

  const handleOpenModal = (record) => {
    setShowModal(true);
    setRecordId(record.id);
    setSelectedRecord(record);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedRecord(null);
  };

  const handleOpenModalPayment = async (record) => {
    setShowModalPayment(true);
    setRecordId(record.id);
    setSelectedRecord(record);
    setSelectedInvoices([]);
    setSelectedCategory([]);
    setSelectedUtility("");
    setInvoices([]);
    setHouseSelectedId("");
    setHouseSelectedName("");
    
    // Prefill phone number if it doesn't contain **
    if (record.phone_number && !record.phone_number.includes('**')) {
      setFormDataPayment(prev => ({
        ...prev,
        phone_number: record.phone_number
      }));
    }

    // Auto-select apartment if available (match unreconciled flow)
    let resolvedApartmentId = record.apartment || "";
    if (!resolvedApartmentId && record.apartment_name) {
      const nameMatch = landlordApartment.find(
        a => (a.name || "").toLowerCase() === String(record.apartment_name).toLowerCase()
      );
      if (nameMatch) {
        resolvedApartmentId = nameMatch.id;
      }
    }

    if (resolvedApartmentId) {
      const houses = await handleApartmentSelect(resolvedApartmentId);
      const matchingHouse = houses.find(
        (house) => String(house.house) === String(record.bill_ref_number)
      );
      if (matchingHouse) {
        setHouseSelectedId(String(matchingHouse.house_id));
        setHouseSelectedName(matchingHouse.house);
        if (matchingHouse.tenant_number || matchingHouse.tenant_phone) {
          setFormDataPayment(prev => ({
            ...prev,
            phone_number: matchingHouse.tenant_number || matchingHouse.tenant_phone
          }));
        }
      }
    }
  };
  const handleCloseModalPayment = () => {
    setShowModalPayment(false);
    setShowModal(false);
    setSelectedInvoices([]);
    setFormDataPayment({
      apartment: "",
      house_number: "",
      category: '',
      utility_type: '',
      source: '',
      amount: '',
      paid_date: '',
      phone_number: ''
    });
  };

  const updateReconcile = () => {
    updateRecord(recordId);
  }

  const handleCloseModalReload = () => {
    setShowModal(false); 
  };

  // add payments
  const [houseSelectedId, setHouseSelectedId] = useState("");
  const [invoices, setInvoices] = useState([])
  const [invoiceSelectedId, setInvoiceSelectedId] = useState("");
  const [houseSelectedName, setHouseSelectedName] = useState("")
  const [apartmentHouse, setApartmentHouse] = useState([]);
  const [selectedApartmentId, setSelectedApartmentId] = useState("");
  const [selectedUtilities, setSelectedUtilities] = useState([])
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [selectedUtility, setSelectedUtility] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("");
  const [amountError, setAmountError] = useState("");

  const monthNames = [
    "january", "february", "march", "april", "may", "june",
    "july", "august", "september", "october", "november", "december"
  ];

  async function handleApartmentSelect(selectedApartmentId) {
    setSelectedApartmentId(selectedApartmentId)

    try {
      // get the houses to be listed when apartment is selected
      const [housesRes, utilitiesRes] = await Promise.all([
        serverUrl.get(`/landlord/react-house-apartment-tenant/?apartment_id=${selectedApartmentId}`, config),
        serverUrl.get(`/landlord/expense/?apartment_id=${selectedApartmentId}`, config)
      ]);

      // Filter houses with occupancy status "occupied"
      const occupiedHouses = housesRes.data.results.filter((house) => house.status === 'occupied');
      setApartmentHouse(occupiedHouses);

      // Set utilities
      setSelectedUtilities(utilitiesRes.data.results);
      return occupiedHouses;
    } catch (error) {
      console.log("Error fetching apartment data:", error);
      toast.error("Failed to load apartment details");
      return [];
    }
  }

  function handleHouseSelect(selectedHouseid) {
    setHouseSelectedId(selectedHouseid)

    // Find the selected house object based on its ID
    const selectedHouse = apartmentHouse.find((house) => house.house_id === parseInt(selectedHouseid));

    if (selectedHouse) {
      setHouseSelectedName(selectedHouse.house)
      
      // Auto-populate phone number if available
      if (selectedHouse.tenant_number || selectedHouse.tenant_phone) {
        setFormDataPayment(prev => ({
          ...prev,
          phone_number: selectedHouse.tenant_number || selectedHouse.tenant_phone
        }));
      }
    } else {
      setHouseSelectedName("");
    }

    // If categories are already selected, fetch invoices for the new house
    if (selectedCategory && selectedCategory.length > 0) {
       // Clear existing invoices before fetching new ones
       setInvoices([]);
       selectedCategory.forEach(cat => {
          serverUrl.get(`/landlord/tenant-invoice/?house_id=${selectedHouseid}&reference=${cat}`, config)
          .then((res) => {
            const unpaidInvoices = res.data.results.filter(invoice => invoice.status !== "paid");
             setInvoices(prev => {
                const existingIds = new Set(prev.map(i => i.id));
                const uniqueNew = unpaidInvoices.filter(i => !existingIds.has(i.id));
                return [...prev, ...uniqueNew];
             });
          })
          .catch((error) => {
            console.log(error);
          });
       });
    }
  }

  // form data for tenant details ratings
  const [formDataPayment, setFormDataPayment] = useState({
    apartment: "",
    house_number: "",
    category: '',
    utility_type: '',
    source: '',
    amount: '',
    paid_date: '',
    phone_number: ''
  });

  const handleChangePayment = (event) => {
    const { name, value } = event.target;
    let errorMessage = "";

    if (name === "phone_number") {
      if (!value.startsWith("254") || value.length > 13 || isNaN(value.slice(4))) {
        errorMessage = "Invalid phone number format. Please enter a valid number starting with '254' and followed by up to 9 digits.";
      }
    }
    
    if (name === "amount") {
      // Validate that amount is not greater than overflow amount
      if (selectedRecord && parseFloat(value) > parseFloat(selectedRecord.overflow_amount)) {
        setAmountError(`Amount cannot exceed overflow amount of KES ${parseFloat(selectedRecord.overflow_amount).toLocaleString('en-US')}`);
      } else {
        setAmountError("");
      }
    }

    setFormDataPayment({
      ...formDataPayment,
      [name]: value,
      errorMessage: errorMessage
    });
  }

  // --- FIXED FUNCTION START ---
  const handleCategorySelect = (categoryValue, isChecked) => {
    // 1. Update the selectedCategory array state
    let updatedCategories;
    if (isChecked) {
       updatedCategories = [...selectedCategory, categoryValue];
    } else {
       updatedCategories = selectedCategory.filter(cat => cat !== categoryValue);
    }
    
    setSelectedCategory(updatedCategories);
    setSelectedUtility("");
    setInvoices([]);
    setSelectedInvoices([]); // Clear selected checkboxes

    // 2. Fetch invoices for ALL selected categories
    if (houseSelectedId && updatedCategories.length > 0) {
      updatedCategories.forEach((cat) => {
        serverUrl.get(`/landlord/tenant-invoice/?house_id=${houseSelectedId}&reference=${cat}`, config)
          .then((res) => {
            const unpaidInvoices = res.data.results.filter(invoice => invoice.status !== "paid");
            // Append new results to existing invoices (prevent duplicates)
            setInvoices(prevInvoices => {
               const existingIds = new Set(prevInvoices.map(inv => inv.id));
               const uniqueNewInvoices = unpaidInvoices.filter(inv => !existingIds.has(inv.id));
               return [...prevInvoices, ...uniqueNewInvoices];
            });
          })
          .catch((error) => {
            console.log(error);
          });
      });
    }
  };

  const handlePaymentSelect = (e) => {
    setSelectedMethod(e.target.value);
  };

  function handleInvoiceToggle(invoice) {
    const invoiceId = invoice.id;

    setSelectedInvoices(prev => {
      if (prev.includes(invoiceId)) {
        // Remove if already selected
        return prev.filter(id => id !== invoiceId);
      } else {
        // Add if not selected
        return [...prev, invoiceId];
      }
    });
  }

  function calculateTotalInvoiceAmount() {
    return selectedInvoices.reduce((total, invoiceId) => {
      const invoice = invoices.find(inv => inv.id === invoiceId);
      return total + (invoice ? parseFloat(invoice.amount) : 0);
    }, 0);
  }


function handleSavePayment(e) {
  e.preventDefault();
  
  if (selectedInvoices.length === 0) {
    toast.error('Please select at least one invoice');
    return;
  }

  if (!houseSelectedId) {
    toast.error('Please select a house');
    return;
  }

  if (
    selectedApartmentId &&
    landlordApartment.length > 0 &&
    !landlordApartment.some(a => String(a.id) === String(selectedApartmentId))
  ) {
    toast.error('Please select a valid property');
    return;
  }
  
  // Validate amount
  if (selectedRecord && parseFloat(formDataPayment.amount) > parseFloat(selectedRecord.overflow_amount)) {
    toast.error(`Amount cannot exceed overflow amount of KES ${parseFloat(selectedRecord.overflow_amount).toLocaleString('en-US')}`);
    return;
  }
  
  const getCurrentTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  };
  
  const currentTime = getCurrentTime();
  const selectedHouse = apartmentHouse.find((house) => house.house_id === parseInt(houseSelectedId, 10));
  if (!selectedHouse) {
    toast.error('Selected house details could not be found. Please reselect the house.');
    return;
  }

  const fullName = selectedHouse.tenant || selectedRecord?.first_name || "Tenant";
  const firstName = fullName.split(' ')[0];

  const formData = {
    transcation_type: selectedMethod,
    transcation_id: selectedMethod + selectedHouse.house + currentTime,
    bill_ref_number: selectedHouse.house,
    apartment: selectedApartmentId,
    transcation_time: currentTime,
    transcation_amount: formDataPayment.amount,
    phone_number: formDataPayment.phone_number,
    first_name: firstName,
  };

  // Post the data to the ctob
  serverUrl.post(`/landlord/c2btranscation/`, formData, config)
    .then((res) => {
      const invoiceIdsParam = selectedInvoices.join(',');
      return serverUrl.get(
        `/landlord/reconcile_transactions/?c2btransaction_id=${res.data.id}&house_id=${houseSelectedId}&invoice_ids=${invoiceIdsParam}`,
        config
      )
        .then(() => {
          // Calculate the new overflow amount
          const newOverflowAmount = parseFloat(selectedRecord.overflow_amount) - parseFloat(formDataPayment.amount);
          const updateData = {
            overflow_amount: newOverflowAmount,
            reason_for_failed_reconciliation: "",
          };
          
          serverUrl.patch(`/landlord/c2btranscation/${recordId}/`, updateData, config)
            .then(() => {
              // Close modal
              setShowModalPayment(false);
              setShowModal(false);
              
              // Show success message
              toast.success(`Successfully reconciled payment for ${selectedInvoices.length} invoice(s)!`);
              
              // Update the transaction in state instead of reloading page
              setCtobTransactions(prev => 
                prev.map(transaction => 
                  transaction.id === recordId 
                    ? { ...transaction, overflow_amount: newOverflowAmount }
                    : transaction
                ).filter(transaction => transaction.overflow_amount > 0) // Remove if overflow is now 0
              );
              
              // Reset all form states
              setSelectedRecord(null);
              setRecordId('');
              setSelectedInvoices([]);
              setSelectedCategory([]);
              setSelectedUtility('');
              setInvoices([]);
              setHouseSelectedId('');
              setSelectedApartmentId('');
              setFormDataPayment({
                apartment: "",
                house_number: "",
                category: '',
                utility_type: '',
                source: '',
                amount: '',
                paid_date: '',
                phone_number: ''
              });
            })
            .catch((error) => {
              console.log(error);
              toast.error('Payment was processed but overflow amount update failed');
              // Still reload on error to ensure data consistency
              setTimeout(() => window.location.reload(), 2000);
            });
        })
        .catch((error) => {
          console.log(error);
          toast.error('Payment reconciliation failed');
          // Reload on error to ensure data consistency
          setTimeout(() => window.location.reload(), 2000);
        });
    })
    .catch((error) => {
      console.log(error);
      toast.error('Failed to process payment');
    });
}

  const exportCSV = () => {
    const csvData = [
      ['Paid Number', 'Paid By', 'Amount Paid', 'Overflow Amount', 'Transaction Id', 'Transaction Type', 'Date Paid'],
      ...ctobTransactions.map((item) => [item.phone_number, item.first_name, item.transcation_amount, item.overflow_amount, item.transcation_id, item.transcation_type, item.transcation_time]),
    ];
    const csvBlob = new Blob([csvData.join('\n')], { type: 'text/csv;charset=utf-8;' });
    saveAs(csvBlob, 'overflow_report.csv');
  };

  const updateRecord = (recordId) => {
    if (!window.confirm("Delete this overpayment? This cannot be undone.")) return;
    serverUrl.delete(`/landlord/c2btranscation/${recordId}/`, config)
      .then((res) => {
        toast.success('The Amount Is Successfully Removed From Our Tables!')
        setCtobTransactions(prev => 
          prev.filter(transaction => transaction.id !== recordId)
                  );
        
        // Close modals
        setShowModal(false);
        setSelectedRecord(null);
        setRecordId('');

      })
      .catch((error) => {
        console.log(error)
        toast.error('Failed to update record');
      });
  };

  const addManualOverpayment = (event) => {
    event.preventDefault();
    const amount = Number(manualOverpayment.overflow_amount);
    const payload = {
      ...manualOverpayment,
      apartment: Number(manualApartmentId || id),
      transcation_amount: String(amount),
      overflow_amount: amount,
      transcation_type: "manual-overpayment",
      reconciled: false,
      transcation_id: manualOverpayment.transcation_id || `MANUAL-${Date.now()}`,
      reason_for_failed_reconciliation: "Manually added overpayment",
    };
    serverUrl.post("/landlord/c2btranscation/", payload, config)
      .then(({ data }) => {
        setCtobTransactions((current) => [data, ...current]);
        setShowAddOverpayment(false);
        toast.success("Overpayment added.");
      })
      .catch((error) => toast.error(error.response?.data?.detail || "Unable to add overpayment."));
  };

  const loadManualUnits = async (apartmentId) => {
    setManualApartmentId(String(apartmentId || ""));
    setManualOverpayment((current) => ({ ...current, bill_ref_number: "" }));
    if (!apartmentId) {
      setManualUnits([]);
      return;
    }
    setIsLoadingManualUnits(true);
    try {
      const response = await serverUrl.get(
        `/landlord/react-house-apartment-tenant/?apartment_id=${apartmentId}`,
        config
      );
      setManualUnits(response.data?.results || []);
    } catch (error) {
      setManualUnits([]);
      toast.error("Unable to load units for this property.");
    } finally {
      setIsLoadingManualUnits(false);
    }
  };

  const openAddOverpayment = () => {
    setShowAddOverpayment(true);
    if (!isAllProperties) {
      loadManualUnits(id);
    }
  };

  const SortIcon = ({ field }) => {
    if (sortType !== field) return <i className='bi bi-filter-left ml-1'></i>;
    return sortOrder === "asc"
      ? <i className='bi bi-chevron-up ml-1'></i>
      : <i className='bi bi-chevron-down ml-1'></i>;
  };

  if (isLoading) {
    return (
      <div className="flex flex-col justify-center items-center h-screen">
        <img src={loaderImageGif} alt="Loading..." style={{ width: "400px" }} />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container-fluid px-4 py-3">
        <div className="bg-white rounded-lg shadow-md p-6">
          <div className="flex justify-between items-center mb-6">
            <h2 className="text-2xl font-bold text-yellow-500">Overpayment Report</h2>

            <div className="flex items-center space-x-4">
              <button
                onClick={openAddOverpayment}
                className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
              >
                Add overpayment
              </button>
              <button
                onClick={exportCSV}
                className="flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors"
              >
                <span>EXCEL</span>
                <i className='bi bi-file-earmark-excel ml-2'></i>
              </button>

              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <i className="bi bi-search text-gray-400"></i>
                </div>
                <input
                  type="text"
                  placeholder="Search transactions..."
                  value={searchQuery}
                  onChange={handleSearch}
                  className="pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                />
              </div>
            </div>
          </div>

          {showAddOverpayment && (
            <div className="fixed inset-0 z-50 flex justify-center items-center bg-slate-900/30 backdrop-blur-sm p-4 overflow-y-auto">
              <form onSubmit={addManualOverpayment} className="bg-white shadow-2xl my-6 p-6 rounded-xl w-full max-w-lg">
                <div className="flex justify-between items-center mb-5 pb-3 border-b">
                  <h3 className="font-semibold text-gray-900 text-lg">Add manual overpayment</h3>
                  <button
                    type="button"
                    onClick={() => setShowAddOverpayment(false)}
                    className="text-gray-400 hover:text-gray-700 text-2xl leading-none"
                  >
                    &times;
                  </button>
                </div>
                <div className="gap-4 grid grid-cols-1 sm:grid-cols-2">
                  {isAllProperties && (
                    <div className="sm:col-span-2">
                      <p className="mb-1 font-medium text-gray-700 text-sm">Property</p>
                      <select
                        className="bg-white px-3 py-2 border border-gray-300 rounded-md w-full"
                        value={manualApartmentId}
                        onChange={(event) => loadManualUnits(event.target.value)}
                        required
                      >
                        <option value="">Select property</option>
                        {landlordApartment.map((apartment) => (
                          <option key={apartment.id} value={apartment.id}>
                            {apartment.name || apartment.apartment_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="sm:col-span-2">
                    <p className="mb-1 font-medium text-gray-700 text-sm">Unit</p>
                    <select
                      className="bg-white px-3 py-2 border border-gray-300 rounded-md w-full"
                      required
                      disabled={!manualApartmentId || isLoadingManualUnits}
                      value={manualOverpayment.bill_ref_number}
                      onChange={(event) => {
                        const selectedUnit = manualUnits.find(
                          (unit) => String(unit.house) === event.target.value
                        );
                        setManualOverpayment({
                          ...manualOverpayment,
                          bill_ref_number: selectedUnit?.house || "",
                          phone_number:
                            selectedUnit?.tenant_number ||
                            selectedUnit?.tenant_phone ||
                            "",
                        });
                      }}
                    >
                      <option value="">
                        {isLoadingManualUnits ? "Loading units..." : "Select unit"}
                      </option>
                      {manualUnits.map((unit) => (
                        <option key={unit.house_id} value={unit.house}>
                          {unit.house}
                        </option>
                      ))}
                    </select>
                  </div>
                  {[
                    ["first_name", "Paid by", "text"],
                    ["phone_number", "Phone number", "tel"],
                    ["overflow_amount", "Amount", "number"],
                    ["transcation_id", "Transaction reference (optional)", "text"],
                  ].map(([name, fieldLabel, inputType]) => (
                    <div key={name}>
                      <p className="mb-1 font-medium text-gray-700 text-sm">{fieldLabel}</p>
                      <input
                        className="px-3 py-2 border border-gray-300 rounded-md w-full"
                        type={inputType}
                        min={name === "overflow_amount" ? "0.01" : undefined}
                        step={name === "overflow_amount" ? "0.01" : undefined}
                        required={!["phone_number", "transcation_id"].includes(name)}
                        value={manualOverpayment[name]}
                        onChange={(event) => setManualOverpayment({
                          ...manualOverpayment,
                          [name]: event.target.value,
                        })}
                      />
                    </div>
                  ))}
                  <div className="sm:col-span-2">
                  <p className="mb-1 font-medium text-gray-700 text-sm">Payment date</p>
                  <input
                    className="px-3 py-2 border border-gray-300 rounded-md w-full"
                    type="date"
                    required
                    value={manualOverpayment.transcation_time}
                    onChange={(e) => setManualOverpayment({ ...manualOverpayment, transcation_time: e.target.value })}
                  />
                  </div>
                </div>
                <div className="flex justify-end gap-2 mt-6 pt-4 border-t">
                  <button type="button" onClick={() => setShowAddOverpayment(false)} className="px-4 py-2 bg-gray-200 rounded">Cancel</button>
                  <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded">Save</button>
                </div>
              </form>
            </div>
          )}

          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {[
                    { key: "phone_number", label: "Paid Number" },
                    { key: "first_name", label: "Paid By" },
                    { key: "bill_ref_number", label: "Unit" },
                    { key: "apartment_name", label: "Apartment" },
                    { key: "transcation_amount", label: "Amount Paid" },
                    { key: "overflow_amount", label: "Overflow Amount" },
                    { key: "transcation_id", label: "Transaction Id" },
                    { key: "transcation_type", label: "Transaction Type" },
                    { key: "transcation_time", label: "Date Paid" },
                    { key: "action", label: "Reconcile Transaction" }
                  ].map((header) => (
                    <th
                      key={header.key}
                      className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100"
                      onClick={() => header.key !== "action" && handleSort(header.key)}
                    >
                      <div className="flex items-center">
                        {header.label}
                        {header.key !== "action" && <SortIcon field={header.key} />}
                      </div>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {displayedItems.length === 0 ? (
                  <tr>
                    <td colSpan="10" className="px-6 py-4 text-center text-gray-500">
                      {searchQuery ? "No matching transactions found" : "No overpayment transactions available"}
                    </td>
                  </tr>
                ) : (
                  displayedItems.map((transaction, index) => (
                    <tr key={index} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {transaction.phone_number}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {transaction.first_name}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {transaction.bill_ref_number}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {transaction.apartment_name || "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        KES {parseInt(transaction.transcation_amount).toLocaleString('en-US')}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-red-600">
                        KES {parseFloat(transaction.overflow_amount).toLocaleString('en-US')}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {transaction.transcation_id}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {transaction.transcation_type}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                        {isNaN(new Date(transaction.transcation_time)) ? (
                          `${transaction.transcation_time.substr(6, 2)}-${transaction.transcation_time.substr(4, 2)}-${transaction.transcation_time.substr(0, 4)}`
                        ) : (
                          new Date(transaction.transcation_time).toLocaleDateString()
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                        <button
                          onClick={() => handleOpenModal(transaction)}
                          className="text-purple-600 hover:text-purple-900 bg-purple-100 hover:bg-purple-200 px-3 py-1 rounded-md transition-colors"
                        >
                          Revise Overflow
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {filteredData.length > 0 && (
            <div className="flex items-center justify-between mt-4 px-2">
              <div className="text-sm text-gray-700">
                Showing <span className="font-medium">{startIndex + 1}</span> to{" "}
                <span className="font-medium">{endIndex}</span> of{" "}
                <span className="font-medium">{filteredData.length}</span> results
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={handlePrevPage}
                  disabled={currentPage === 0}
                  className={`px-3 py-1 rounded-md ${currentPage === 0
                    ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                >
                  Previous
                </button>
                <button
                  onClick={handleNextPage}
                  disabled={currentPage === totalPages - 1}
                  className={`px-3 py-1 rounded-md ${currentPage === totalPages - 1
                    ? "bg-gray-200 text-gray-400 cursor-not-allowed"
                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"}`}
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Revise Overflow Modal */}
      <div className={`fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50 ${showModal ? 'block' : 'hidden'}`}>
        <div className="relative top-20 mx-auto  border w-11/12 md:w-1/2 lg:w-1/3 shadow-lg rounded-md bg-white">
          <div className="px-6 py-4 border-b border-gray-200 flex justify-between items-center">
            <h3 className="text-lg font-medium text-gray-900">Revise Overflow</h3>
            <button onClick={handleCloseModal} className="text-gray-400 hover:text-gray-500">
              <b className="text-2xl">X</b>
            </button>
          </div>

          {selectedRecord && (
            <div className="px-6 py-4 bg-gray-50">
              <div className="grid grid-cols-2 gap-4 text-sm">
                <div>
                  <p className="text-gray-500">Transaction ID</p>
                  <p className="font-medium">{selectedRecord.transcation_id}</p>
                </div>
                <div>
                  <p className="text-gray-500">Overflow Amount</p>
                  <p className="font-medium text-red-600">KES {parseFloat(selectedRecord.overflow_amount).toLocaleString('en-US')}</p>
                </div>
                <div>
                  <p className="text-gray-500">Paid By</p>
                  <p className="font-medium">{selectedRecord.first_name}</p>
                </div>
                <div>
                  <p className="text-gray-500">Phone Number</p>
                  <p className="font-medium">{selectedRecord.phone_number}</p>
                </div>
              </div>
            </div>
          )}

          <div className="px-6 py-4 flex justify-between">
            <button
              onClick={updateReconcile}
              className="px-4 py-2 bg-yellow-500 text-white rounded-md hover:bg-yellow-600 transition-colors"
            >
              Refund Overflow
            </button>
            <button
              onClick={() => handleOpenModalPayment(selectedRecord)}
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
            >
              Reconcile
            </button>
          </div>

          <div className="px-6 py-4 border-t border-gray-200 flex justify-end">
            <button
              onClick={handleCloseModalReload}
              className="px-4 py-2 bg-green-500 text-white rounded-md hover:bg-green-600 transition-colors"
            >
              Done
            </button>
          </div>
        </div>
      </div>

      {/* Reconcile Payment Modal */}
      <ReconcilePaymentModal
        showModalPayment={showModalPayment}
        selectedRecord={selectedRecord}
        formDataPayment={formDataPayment}
        amountError={amountError}
        landlordApartment={landlordApartment}
        apartmentHouse={apartmentHouse}
        selectedApartmentId={selectedApartmentId}
        houseSelectedId={houseSelectedId}
        selectedCategory={selectedCategory}
        selectedUtilities={selectedUtilities}
        selectedUtility={selectedUtility}
        invoices={invoices}
        selectedInvoices={selectedInvoices}
        handleCloseModalPayment={handleCloseModalPayment}
        handleSavePayment={handleSavePayment}
        handleChangePayment={handleChangePayment}
        handleApartmentSelect={handleApartmentSelect}
        handleHouseSelect={handleHouseSelect}
        handleCategorySelect={handleCategorySelect}
        setSelectedUtility={setSelectedUtility}
        handleInvoiceToggle={handleInvoiceToggle}
        calculateTotalInvoiceAmount={calculateTotalInvoiceAmount}
      />
    </div>
  );
}

export default OverflowReport;
